function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b985f0ea-5e67-49db-9fe2-a45a76b6e4c8{fill:none;stroke:#f65e5c;stroke-width:12px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "b5a59f7c-831b-4653-8119-11bda7610bc1",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "b209eb7e-fea9-41f9-ae65-8cc7116f2fa4",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "b7d8ba77-baec-49f9-a7c4-04e284294359",
  "data-name": "Path 66",
  className: "b985f0ea-5e67-49db-9fe2-a45a76b6e4c8",
  d: "M99.7,65.89a93.6,93.6,0,1,1-93.6,93.6S-2.7,59.89,141,11.89Z"
})));

var SvgLogoIcon2 = function SvgLogoIcon2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 199.3 259.09",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon (2).f96a7bb2.svg";
export { ForwardRef as ReactComponent };